<template>
  <b-form @submit.prevent="onSubmit">
    <b-form-group
      id="Lident"
      label="Identifica"
      label-for="ident"
      description="ID del tramo"
    >
      <b-form-input
        id="ident"
        v-model="form.identifica"
        :required="true"
        :disabled="true"
      />
    </b-form-group>
    <b-form-group
      id="Lsc"
      label="Suncuenca"
      label-for="sc"
      description="Subcuenca"
    >
      <b-form-input
        id="sc"
        v-model="form.inspeccion_subcuenca"
        :required="true"
        :disabled="true"
      />
    </b-form-group>
    <b-form-group
      id="Lfechai"
      label="Fecha"
      label-for="fechai"
      description="Fecha de Inspeccion"
    >
      <date-picker
        id="fechai"
        v-model="form.inspeccion_fecha"
        valueType="format"
        lang="es"
        :placeholder="(form.inspeccion_fecha!=null)?new Date(form.inspeccion_fecha).toLocaleDateString():null"
        :required="true"
        :first-day-of-week="1"
      ></date-picker>
    </b-form-group>
    <b-form-group
      id="label6"
      label="Ispección"
      label-for="input6"
      description="Estado de la inspeccion"
    >
      <b-form-select
        id="input6"
        v-model="form.inspeccion_tipo"
        :options="optionitv"
        :required="true"
      />
    </b-form-group>
    <b-form-group
      id="Lorden"
      label="ODS"
      label-for="orden"
      description=" N° Orden"
    >
      <b-form-input id="orden" type="number" v-model="form.inspeccion_orden" />
    </b-form-group>
    <b-form-group
      v-show="form.inspeccion_tipo === 'Si'"
      id="Lmetros"
      label="Longitud"
      label-for="metros"
      description="Longitud de terreno"
    >
      <b-form-input
        id="metros"
        v-model="form.inspeccion_longitud"
        :required="form.inspeccion_tipo === 'Si'"
      />
    </b-form-group>
    <b-form-group
      id="Lshapel"
      label="Largo"
      label-for="shapel"
      description="largo del shape"
    >
      <b-form-input
        id="shapel"
        v-model="form.inspeccion_longshape"
        :required="true"
        :disabled="true"
      />
    </b-form-group>
    <b-form-group
      v-show="form.inspeccion_tipo === 'No'"
      id="label8"
      label="Causa la no Inspeccion"
      label-for="input8"
      description="La causa por la cual no se inspecciono"
    >
      <b-form-select
        id="input8"
        v-model="form.causa"
        :options="optionsCausas"
        :required="form.inspeccion_tipo === 'No'"
      />
    </b-form-group>
    <b-form-group
      id="Lobs"
      label="Observacion"
      label-for="obs"
      description="Adjuntar informacion sobre la inspeccion"
    >
      <b-form-textarea
        id="obs"
        type="text"
        v-model="form.inspeccion_obs"
        rows="3"
        max-rows="6"
        :required="form.inspeccion_tipo === 'No'"
      />
    </b-form-group>
    <b-form-group
      id="label4"
      v-show="form.inspeccion_tipo === 'Si'"
      label="Operadores"
      label-for="input4"
      description="Operador de ITV"
    >
      <b-form-select
        id="input4"
        v-model="form.operadoritv"
        :options="optionsOperadores"
        @change="patenteToOperador"
        :required="form.inspeccion_tipo === 'Si'"
      />
    </b-form-group>
    <b-form-group
      id="label3"
      v-show="form.inspeccion_tipo === 'Si'"
      label="Patente"
      label-for="input3"
      description="Patente del camion"
    >
      <b-form-select
        id="input3"
        v-model="form.patenteitv"
        :options="optionsPatentes"
        :required="form.inspeccion_tipo === 'Si'"
      />
    </b-form-group>
    <!----------------------->
    <b-form-group
      id="Linicio"
      label="Inicio"
      label-for="inicio"
      description=" Hora de inicio"
      v-show="form.inspeccion_tipo === 'Si'"
    >
      <date-picker
        id="inicio"
        v-model="form.inspeccion_inicio"
        lang="es"
        :placeholder="(form.inspeccion_inicio!=null)?new Date(form.inspeccion_inicio).toLocaleTimeString():null"
        type="time"
        @change="calculahora"
        format="HH:mm:ss"
        :required="form.inspeccion_tipo === 'Si'"
      ></date-picker>
    </b-form-group>
    <b-form-group
      id="Lfin"
      label="Fin"
      label-for="fin"
      description=" Hora de finalizado"
      v-show="form.inspeccion_tipo === 'Si'"
    >
      <date-picker
        id="fin"
        v-model="form.inspeccion_fin"
        lang="es"
        type="time"
        :placeholder="(form.inspeccion_fin!=null)?new Date(form.inspeccion_fin).toLocaleTimeString():null"
        format="HH:mm:ss"
        @change="calculahora"
        :required="form.inspeccion_tipo === 'Si'"
      >
      </date-picker>
    </b-form-group>
    <b-form-group
      id="Ltiempo"
      v-show="form.inspeccion_tipo === 'Si'"
      label="Tiempo"
      label-for="tiempo"
      description="Tiempo de ejecucion"
    >
      <b-form-input
        id="tiempo"
        v-model="form.inspeccion_tiempo"
        :disabled="true"
      />
    </b-form-group>
    <b-button type="submit" variant="primary">Enviar</b-button>
  </b-form>
</template>

<script>
/* eslint-disable no-console */

import Http from "../Http";
import DatePicker from "vue2-datepicker";
import EventBus from "../Bus";
import store from "../store/";

export default {
  name: "inspeccion",
  components: { DatePicker },
  props: ["subcu", "identifica", "shal", "predata", "datos"],
  computed: {
    optionsCausas() {
      return this.causas
        .filter(x => x.causa_id !== 19)
        .map(x => ({
          value: x.causa_id,
          text: x.causa_nombre
        }));
    },
    optionsOperadores() {
      return this.operadoritv
        .filter(x => x.itv_id !== 8)
        .map(x => ({
          value: x.itv_id,
          text: x.itv_nombre
        }));
    },
    optionsPatentes() {
      return this.patenteitv
        .filter(x => x.patente_id !== 9)
        .map(x => ({
          value: x.patente_id,
          text: x.patente_nombre
        }));
    }
  },
  data: () => ({
    causas: [],
    optionitv: [
      { value: null, text: "Seleccione una opcion" },
      { value: "Si", text: "SI" },
      { value: "No", text: "NO" },
      { value: "Solicitado", text: "Solicitado" }
    ],
    form: {
      identifica: null,
      inspeccion_subcuenca: null,
      inspeccion_fecha: null,
      inspeccion_tipo: null,
      inspeccion_longitud: null,
      inspeccion_longshape: null,
      causa: null,
      inspeccion_obs: null,
      operadoritv: null,
      patenteitv: null,
      inspeccion_inicio: null,
      inspeccion_fin: null,
      inspeccion_tiempo: null,
      inspeccion_orden: null
    },
    lang: {
      days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      pickers: [
        "next 7 days",
        "next 30 days",
        "previous 7 days",
        "previous 30 days"
      ],
      placeholder: {
        date: "Seleccione Fecha",
        dateRange: "Seleccione Rango"
      }
    },
    operadoritv: [],
    patenteitv: []
  }),
  mounted() {
    this.form.identifica = this.identifica;
    this.form.inspeccion_subcuenca = this.subcu;
    this.form.inspeccion_longshape = this.shal;
    this.getCausas();
    this.getOperadoritv();
    this.getPatente();
    if(this.datos!=null){
      console.log("demto de datos")
      this.cargarDatositv();
    }
  },
  methods: {
    getCausas() {
      Http.Http()
        .get("Preinf/Causalvd")
        .then(resp => {
          this.causas = resp.data;
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    getOperadoritv() {
      Http.Http()
        .get("Informef/opitv")
        .then(resp => {
          console.log(resp);
          this.operadoritv = resp.data;
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    getPatente() {
      Http.Http()
        .get("Informef/Patenteitvs")
        .then(resp => {
          console.log(resp);
          this.patenteitv = resp.data;
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
    patenteToOperador() {
      let patente = this.operadoritv.find(
        x => x.itv_id === this.form.operadoritv
      );
      console.log(patente);
      this.form.patenteitv = patente.itv_patente;
    },
    calculahora() {
      let tiempo = this.form.inspeccion_fin - this.form.inspeccion_inicio;
      this.form.inspeccion_tiempo =
        tiempo >= 0 ? tiempo / 1000 / 60 / 60 + " Hrs" : "";
    },
    cargarDatositv() {
      let tmp = this.datos;
      this.form.inspeccion_fecha = tmp.inspeccion_fecha;
      this.form.inspeccion_tipo = tmp.inspeccion_tipo;
      this.form.inspeccion_longitud = tmp.inspeccion_longitud;
      this.form.causa = tmp.causa;
      this.form.inspeccion_obs = tmp.inspeccion_obs;
      this.form.operadoritv = tmp.operadoritv;
      this.form.patenteitv = tmp.patenteitv;
      let init = tmp.inspeccion_inicio.split(":");
      this.form.inspeccion_inicio = new Date().setHours(
        init[0],
        init[1],
        init[2]
      );
      let fin = tmp.inspeccion_fin.split(":");
      this.form.inspeccion_fin = new Date().setHours(fin[0], fin[1], fin[2]);
      this.form.inspeccion_tiempo = tmp.inspeccion_tiempo;
      this.form.inspeccion_orden = tmp.inspeccion_orden;
    },
    onSubmit() {
      let form = {
        identifica: this.form.identifica,
        inspeccion_subcuenca: this.form.inspeccion_subcuenca,
        inspeccion_fecha: this.form.inspeccion_fecha,
        inspeccion_tipo: this.form.inspeccion_tipo,
        inspeccion_longshape: this.form.inspeccion_longshape,
        user_id: store.state.User.CurrentUser.user_id
      };
      if (this.form.inspeccion_tipo === "No") {
        Object.defineProperty(form, "causa", {
          value: this.form.causa,
          writable: true,
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(form, "inspeccion_obs", {
          value: this.form.inspeccion_obs,
          writable: true,
          enumerable: true,
          configurable: true
        });
      }
      if (this.form.inspeccion_tipo === "Si") {
        Object.defineProperties(form, {
          inspeccion_longitud: {
            value: this.form.inspeccion_longitud,
            writable: true,
            enumerable: true,
            configurable: true
          },

          operadoritv: {
            value: this.form.operadoritv,
            writable: true,
            enumerable: true,
            configurable: true
          },
          patenteitv: {
            value: this.form.patenteitv,
            writable: true,
            enumerable: true,
            configurable: true
          },
          inspeccion_inicio: {
            value: new Date(this.form.inspeccion_inicio).toLocaleTimeString(),
            writable: true,
            enumerable: true,
            configurable: true
          },
          inspeccion_fin: {
            value: new Date(this.form.inspeccion_fin).toLocaleTimeString(),
            writable: true,
            enumerable: true,
            configurable: true
          },
          inspeccion_tiempo: {
            value: this.form.inspeccion_tiempo,
            writable: true,
            enumerable: true,
            configurable: true
          }
        });
        if (this.form.inspeccion_obs != null) {
          Object.defineProperty(form, "inspeccion_obs", {
            value: this.form.inspeccion_obs,
            writable: true,
            enumerable: true,
            configurable: true
          });
        }
      }
      if (this.form.inspeccion_orden != null) {
        Object.defineProperty(form, "inspeccion_orden", {
          value: this.form.inspeccion_orden,
          writable: true,
          enumerable: true,
          configurable: true
        });
      }
      if (this.datos == null) {
        Http.Http()
          .post("Informef/itv", {
            data: JSON.stringify(this.predata),
            accion: JSON.stringify(form)
          })
          .then(resp => {
              if(resp.data===10){
                  alert("Datos previos existentes");
              }
              else {
                  alert("Los datos se an insertado");
                  EventBus.$emit("onPostdata", {
                      id: this.form.identifica,
                      state: resp.data
                  });
              }
          })
          .catch(err => console.log(err));
      } else this.update(form);
    },
    update(form) {
      Object.defineProperty(form, "inspeccion_id", {
        value: this.datos.inspeccion_id,
        writable: true,
        enumerable: true,
        configurable: true
      });
      Http.Http()
        .put("Informef/itv", {
          data: JSON.stringify(this.predata),
          accion: JSON.stringify(form)
        })
        .then(resp => {
          console.log(resp);
          alert("Los datos se actualizaron con exito");
          EventBus.$emit("onPostdata", null);
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style scoped></style>
